import BasketService from "@/services/BasketService.js";

export default {
    /**
     * Updates basket in store and performs other actions.
     * @param context
     * @param data
     */
    updateBasket: function (context, data) {
        context.commit("UDPATE_BASKET", data);
        context.dispatch('updateBasketPacksQty', data.basket.allPacksQty);
    },
    updateBasketPacksQty: function (context, qty) {
        const selector = '.js-basket-packs-count';
        if (qty < 1) {
            $(selector).hide();
            return;
        }
        $(selector).show();
        $(selector).html(qty);
    },
    editConfigurator: function (context, payload) {
        var promise = BasketService.getConfiguratorURL(payload.uid);
        promise.then(function (response) {
            window.location.href = response.data.url;
        });
    },
    changeBasketPackQuantity: function (context, payload) {
        context.commit("LOADING_CONTENT", true);
        var promise = BasketService.changePackQuantity(
            payload.uid,
            payload.quantity
        );
        promise.then(function (response) {
            context.dispatch('updateBasket', response.data);
            context.commit("UPDATE_USER", response.data);
        }).finally(function () {
            context.commit("LOADING_CONTENT", false);
        });
    },
    removeItemPack: function (context, payload) {
        context.commit("LOADING_CONTENT", true);
        var promise = BasketService.ajaxRemoveItemPack(payload.uid);
        promise.then(function (response) {
            context.dispatch('updateBasket', response.data);
            context.commit("UPDATE_USER", response.data);
            context.dispatch('checkPackagings', response.data);
        }).finally(function () {
            context.commit("LOADING_CONTENT", false);
        });
    },
    ajaxSaveBed: function (context, payload) {
        context.commit("LOADING_CONTENT", true);
        var promise = BasketService.ajaxSaveBed(payload.bed);
        promise.then(function (response) {
            var packNameChange = {
                uid: payload.basketItemPackUID,
                name: response.data.data.bed.name
            }
            context.commit("UPDATE_BASKET_PACK_NAME", packNameChange);
        }).finally(function () {
            context.commit("LOADING_CONTENT", false);
        });
        return promise;
    },
    validateVoucher(context, payload) {
        context.commit("LOADING_CONTENT", true);
        return new Promise(function (resolve, reject) {
            BasketService.validateVoucher(payload.code)
                .then(function (response) {
                    if (response.data.hasOwnProperty('error')) {
                        reject({error: response.data.error})
                    } else {
                        context.dispatch('updateBasket', response.data);
                        context.commit("UPDATE_USER", response.data);
                        resolve();
                    }
                })
                .finally(function () {
                    context.commit("LOADING_CONTENT", false);
                })
        });
    },
    removeVoucher(context, payload) {
        context.commit("LOADING_CONTENT", true);
        return new Promise(function (resolve, reject) {
            BasketService.removeVoucher(payload.code)
                .then(function (response) {
                    if (response.data.hasOwnProperty('error')) {
                        reject({error: response.data.error})
                    } else {
                        context.dispatch('updateBasket', response.data);
                        context.commit("UPDATE_USER", response.data);
                        resolve();
                    }
                })
                .finally(function () {
                    context.commit("LOADING_CONTENT", false);
                })
        });
    },
    editTransportationAndPayment: function (context, payload) {
        window.location.href = URLSource.orderTransportAndPayment;
    },
    backToStore: function (context, payload) {
        window.location.href = URLSource.backToStore;
    },
    orderSumarize: function (context, payload) {
        window.location.href = URLSource.orderSummarize;
    },
    changeBasketItemQuantity: function (context, payload) {
        context.commit("LOADING_CONTENT", true);
        return new Promise(function (resolve, reject) {
            BasketService.changeItemQuantity(
                payload.id,
                payload.quantity,
                payload.configuratorUid
            ).then(function (response) {
                context.dispatch('updateBasket', response.data);
                context.commit("UPDATE_USER", response.data);
                context.dispatch('checkPackagings', response.data);
                resolve();
            }).catch(function () {
                reject();
            }).finally(function () {
                context.commit("LOADING_CONTENT", false);
            });
        });
    },
    removeBasketItem: function (context, payload) {
        return new Promise(function (resolve, reject) {
            BasketService.removeItem(
                payload.id,
            ).then(function (response) {
                context.dispatch('updateBasket', response.data);
                context.commit("UPDATE_USER", response.data);
                context.dispatch('checkPackagings', response.data);
                resolve();
            }).catch(function () {
                reject();
            }).finally(function () {
                context.commit("LOADING_CONTENT", false);
            });
        });
    },
    setApplyCredits: function (context, payload) {
        context.commit("LOADING_CREDITS", true);
        var promise = BasketService.setApplyCreditsBasket(
            payload.value
        );
        promise.then(function (response) {
            context.commit("UPDATE_USER", response.data);
        }).catch(function (error) {
        }).finally(function () {
            context.commit("LOADING_CREDITS", false);
        });
    },
    checkPackagings: function (context, data) {
        if (data.packagingItemsIsSame === false) {
            popupOpen('#popup-packaging-check');
        }
    }
};
